import React, { useState } from 'react';
import { ArrowSquareOut, WhatsappLogo, CheckCircle } from '@phosphor-icons/react';
import { CHATNEX_FEATURES, CHATNEX_URL, WHATSAPP_COMMERCE_FEATURES } from '../data/chatnex';

const FeatureGrid = ({ items }) => (
  <div className="grid sm:grid-cols-2 gap-3">
    {items.map((item) => (
      <article
        key={item.title}
        className="rounded-2xl border border-green-100 dark:border-green-900/40 bg-white dark:bg-dark-800 p-4 hover:-translate-y-0.5 hover:shadow-medium smooth-transition"
      >
        <div className="flex items-start gap-2.5 mb-2">
          <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 shrink-0 mt-0.5" weight="fill" />
          <h4 className="font-display font-extrabold text-gray-900 dark:text-white leading-snug">{item.title}</h4>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed pl-7">{item.description}</p>
      </article>
    ))}
  </div>
);

const ChatNexShowcase = () => {
  const [tab, setTab] = useState('features');

  return (
    <div className="space-y-5">
      <a
        href={CHATNEX_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 rounded-2xl overflow-hidden border border-green-200 dark:border-green-800 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-950/40 dark:to-dark-800 p-4 sm:p-5 hover:shadow-large hover:-translate-y-0.5 smooth-transition"
      >
        <span className="w-12 h-12 rounded-2xl bg-green-600 text-white flex items-center justify-center shrink-0 group-hover:scale-110 smooth-transition">
          <WhatsappLogo className="w-7 h-7" weight="fill" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold uppercase tracking-wider text-green-700 dark:text-green-400">Official product</p>
          <h3 className="text-display text-2xl font-extrabold text-gray-900 dark:text-white">
            Open Chat<span className="text-red-600 dark:text-red-500">Nex</span>
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300">chatnex.in — WhatsApp Business Automation platform</p>
        </div>
        <span className="inline-flex items-center justify-center gap-2 btn-primary text-white w-full sm:w-fit px-5 py-2.5 shrink-0">
          Visit ChatNex
          <ArrowSquareOut className="w-4 h-4" weight="bold" />
        </span>
      </a>

      <div>
        <h3 className="text-display text-2xl font-extrabold text-gray-900 dark:text-white mb-1">
          Chat<span className="text-red-600 dark:text-red-500">Nex</span> Features
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Boost engagement and grow your business with advanced automation tools.
        </p>

        <div className="flex gap-2 overflow-x-auto pb-1 mb-4 sm:flex-wrap sm:overflow-visible">
          <button
            type="button"
            onClick={() => setTab('features')}
            className={`px-4 py-2 rounded-full text-sm font-bold smooth-transition whitespace-nowrap ${
              tab === 'features'
                ? 'text-white bg-gradient-to-r from-green-700 via-emerald-700 to-slate-900 shadow-medium'
                : 'bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300'
            }`}
          >
            ChatNex Features
          </button>
          <button
            type="button"
            onClick={() => setTab('commerce')}
            className={`px-4 py-2 rounded-full text-sm font-bold smooth-transition whitespace-nowrap ${
              tab === 'commerce'
                ? 'text-white bg-gradient-to-r from-green-700 via-emerald-700 to-slate-900 shadow-medium'
                : 'bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300'
            }`}
          >
            Ecommerce, Payments & More
          </button>
        </div>

        {tab === 'features' ? (
          <FeatureGrid items={CHATNEX_FEATURES} />
        ) : (
          <FeatureGrid items={WHATSAPP_COMMERCE_FEATURES} />
        )}
      </div>
    </div>
  );
};

export default ChatNexShowcase;
